import debounce from "./debounce";

export default function throttle(func, wait, options = {}) {
  return debounce(func, wait, {
    leading: "leading" in options ? !!options.leading : true,
    maxWait: wait,
    trailing: "trailing" in options ? !!options.trailing : true,
  });
}
